module.exports = "<div class=\"module-section-container\" *ngIf=\"sectionData.length\">\n    <div class=\"module-section-header\">\n        {{sectionName}}\n    </div>\n\n    <div>\n        <app-module-item *ngFor=\"let element of sectionData\"\n                         [module]=\"element\"\n                         (onDataChange)=\"updateSection($event)\"></app-module-item>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/shared/module-section/module-section.component.html
// module id = ../../../../../src/app/shared/module-section/module-section.component.html
// module chunks = 1